document?.addEventListener('DOMContentLoaded', function () {
    const specialDeliveryText = document.querySelector('.special-delivery');
    const defaultDeliveryTime = document.querySelector('.default-delivery-time');
    
    // Function to check if specialDeliveryText has text content
    function hasSpecialDeliveryText() {
        if (!specialDeliveryText) {
            return false;
        }
        const clone = specialDeliveryText.cloneNode(true);
        const images = clone.querySelectorAll('img');
        images.forEach(img => img.remove());
        const textContent = clone.innerText || clone.textContent || '';
        const trimmedText = textContent.trim();
        return trimmedText.length > 0;
    }
    
    // Function to show/hide special delivery text
    function showSpecialDeliveryText(enabled) {
        if (enabled) {
            // If enabled and element exists, show it
            if (specialDeliveryText) {
                specialDeliveryText.style.display = 'flex';
            }
            defaultDeliveryTime.style.display = 'none';
        } else {
            // If not enabled, hide special text and show dates
            if (specialDeliveryText) {
                specialDeliveryText.style.display = 'none';
            }
            defaultDeliveryTime.style.display = 'block';
        }
    }
    
    // Function to calculate and insert delivery dates
    function calculateAndInsertDates(ukHolidays) {
        let deliveryTime = document.querySelector('[data-delivery-time]')?.getAttribute('data-delivery-time');
        if (!deliveryTime || deliveryTime.length === 0) {
            deliveryTime = "2-4";
        }
        
        let timeShippingParts = deliveryTime.split('-');
        let initialDay = parseInt(timeShippingParts[0]);
        let finalDay = parseInt(timeShippingParts[1]);
        let businessDaysToAdd = finalDay - initialDay;
        
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        let fromDateCart = addDays(today, initialDay);

        function adjustDeliveryDate(date) {
            let adjustedDate = new Date(date);
            let adjustmentCount = 0;
            while (isSunday(adjustedDate) || isMonday(adjustedDate) || isUKHoliday(adjustedDate, ukHolidays)) {
                adjustedDate = getNextDay(adjustedDate);
                adjustmentCount++;
                if (adjustmentCount > 10) {
                    break;
                }
            }
            return adjustedDate;
        }

        fromDateCart = adjustDeliveryDate(fromDateCart);
        let toDateCart = new Date(fromDateCart);

        while (businessDaysToAdd > 0) {
            toDateCart = getNextDay(toDateCart);
            if (!isSunday(toDateCart) && !isMonday(toDateCart) && !isUKHoliday(toDateCart, ukHolidays)) {
                businessDaysToAdd--;
            }
        }

        const fromDateEl = document.getElementById('fromDate');
        const toDateEl = document.getElementById('toDate');
        if (fromDateEl) {
            fromDateEl.innerHTML = formatDate(fromDateCart);
        }
        if (toDateEl) {
            toDateEl.innerHTML = formatDate(toDateCart);
        }
    }
    
    // Helper functions for date operations
    function formatDate(date) {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const day = date.getDate();
        const daySuffix = day === 1 || day === 21 || day === 31 ? 'st' : day === 2 || day === 22 ? 'nd' : day === 3 || day === 23 ? 'rd' : 'th';
        return `${days[date.getDay()]} ${months[date.getMonth()]} ${day}${daySuffix}`;
    }

    function addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function getNextDay(date) {
        return addDays(date, 1);
    }

    function isSunday(date) {
        return date.getDay() === 0;
    }

    function isMonday(date) {
        return date.getDay() === 1;
    }

    function formatDateForHolidayCheck(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function isUKHoliday(date, ukHolidays) {
        return ukHolidays.includes(formatDateForHolidayCheck(date));
    }
    
    // Get UK holidays
    async function getUKHolidays(year) {
        try {
            const response = await fetch(`https://date.nager.at/api/v2/publicholidays/${year}/gb`);
            const holidaysData = await response.json();
            const ukHolidays = holidaysData.map(holiday => holiday.date);
            return ukHolidays;
        } catch (error) {
            console.error('Error getting UK holidays:', error);
            return [];
        }
    }
    
    // Variable to store holidays for use when variant changes
    let ukHolidaysCache = null;
    
    // Main logic: Check if metaobject has text content and show/hide accordingly
    const currentYear = new Date().getFullYear();
    getUKHolidays(currentYear).then(ukHolidays => {
        ukHolidaysCache = ukHolidays;
        
        // Check if special delivery text exists and has content
        const hasText = hasSpecialDeliveryText();
        
        if (hasText) {
            // If metaobject has text, show special delivery text
            showSpecialDeliveryText(true);
        } else {
            // If no text, calculate and show delivery dates
            showSpecialDeliveryText(false);
            calculateAndInsertDates(ukHolidays);
        }
    });
    
    // COMMENTED OUT: Variant checking functions (in case client changes decision)
    // Centralized function to check active variant and update state
    /*
    function checkActiveVariant() {
        const productVariants = document.querySelectorAll('.variant-button-wrap input[type=radio]');
        let isPreOrderActive = false;
        
        // Find active variant (checked)
        productVariants.forEach(input => {
            if (input.checked) {
                const label = input.nextElementSibling;
                if (label && label.innerText.toLowerCase().includes('pre-order')) {
                    isPreOrderActive = true;
                }
            }
        });
        
        // Update display based on whether it's pre-order or not
        if (isPreOrderActive) {
            // If pre-order, show special text
            showSpecialDeliveryText(true);
        } else {
            // If not pre-order, hide special text and calculate dates
            showSpecialDeliveryText(false);
            if (ukHolidaysCache) {
                calculateAndInsertDates(ukHolidaysCache);
            }
        }
    }
    */
    
    // COMMENTED OUT: Variant change listeners (in case client changes decision)
    /*
    // Detect variant changes
    const productVariants = document.querySelectorAll('.variant-button-wrap input[type=radio]');
    productVariants.forEach(input => {
        // Listener for variant changes
        input.addEventListener('change', function () {
            // Re-execute check when any variant changes
            checkActiveVariant();
        });
    });
    */
});
